import { CommonSelectInput } from 'components/common/form/select';
import { HITTER_SIDES, HitterSide } from 'lib_ts/enums/hitters.enums';
import { clone } from 'lodash';
import useHittersStore from 'stores/use-hitters-store';

export const SelectHitterSide = () => {
  const filters = useHittersStore((s) => s.hitterFilters);
  const loading = useHittersStore((s) => s.loading);

  return (
    <CommonSelectInput
      id="hitters-side"
      name="side"
      placeholder="common.hand"
      options={HITTER_SIDES}
      value={filters.side ?? undefined}
      onChange={(v) =>
        useHittersStore.setState((prev) => {
          const nextFilters = clone(prev.hitterFilters);

          if (!v) {
            nextFilters.side = null;
          } else {
            nextFilters.side = v as HitterSide;
          }

          return {
            hitterFilters: nextFilters,
          };
        })
      }
      disabled={loading}
      optional
    />
  );
};
